import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import styled from 'styled-components';
import StepConnector from '@material-ui/core/StepConnector';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { palette } from '../../../system/styles/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '50%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: palette.blue,
    backgroundColor: palette.blue,
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  circle: {
    color: '#eaeaf0',
    zIndex: 1,
    fontSize: 18,
  },
  completed: {
    color: palette.blue,
    zIndex: 1,
    fontSize: 18,
  },
});

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: palette.blue,
    },
  },
  completed: {
    '& $line': {
      borderColor: palette.blue,
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}>
      {completed ? (
        <RadioButtonCheckedIcon className={classes.completed} />
      ) : (
        <RadioButtonUncheckedIcon className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

QontoStepIcon.defaultProps = {
  active: false,
  completed: false,
};

const Steps = (props) => {
  const classes = useStyles();
  const { className, activeStep, Steps, handleStep } = props;
  const { t } = useTranslation(['admin']);

  return (
    <div className={`${classes.root} ${className}`}>
      <Stepper activeStep={activeStep} orientation="vertical" connector={<QontoConnector />}>
        {Steps.map((label) => (
          <Step key={label?.idx} onClick={() => handleStep(label?.idx)} style={{ cursor: 'pointer' }}>
            <StepLabel StepIconComponent={QontoStepIcon} style={{ cursor: 'pointer' }}>
              {t(label?.title)}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

Steps.propTypes = {
  className: PropTypes.string,
  activeStep: PropTypes.number,
  Steps: PropTypes.arrayOf(PropTypes.object),
  handleStep: PropTypes.func,
};

Steps.defaultProps = {
  className: '',
  activeStep: 0,
  Steps: [],
  handleStep: () => {},
};

export default styled(Steps)`
  span {
    font-size: 14px;
    font-family: ${palette.nereg};
  }
  .MuiPaper-root {
    background: none;
  }
`;
